exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_weather_17CTAlb0W6fODEjzmuVtdO {\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.IA_weatherIcon_Wk8cy_7igMbx3SwQM0MPV {\n  height: 65%;\n  width: fit-content;\n}\n\n.IA_weatherTemperature_3XP_pXHO2OOutjF0axw0Fm {\n  position: relative;\n  text-align: left;\n\n}\n\n.IA_weatherArea_344ewn2e_OmKZBddi4jo_S {\n  position: relative;\n  text-align: left;\n  font-weight: lighter;\n  clear: right;\n}", ""]);

// Exports
exports.locals = {
	"IA_weather": "IA_weather_17CTAlb0W6fODEjzmuVtdO",
	"IA_weatherIcon": "IA_weatherIcon_Wk8cy_7igMbx3SwQM0MPV",
	"IA_weatherTemperature": "IA_weatherTemperature_3XP_pXHO2OOutjF0axw0Fm",
	"IA_weatherArea": "IA_weatherArea_344ewn2e_OmKZBddi4jo_S"
};